
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/[category]",
      function () {
        return require("private-next-pages/c/[category].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/[category]"])
      });
    }
  